// OVERRIDES - TABLE CELL
export default function TableCell(theme) {
  const commonCell = {
    "&:not(:last-of-type)": {
      position: "relative",
      "&:after": {
        position: "absolute",
        content: "''",
        backgroundColor: theme.palette.divider,
        width: 1,
        height: "calc(100% - 30px)",
        right: 0,
        top: 16
      }
    }
  };

  return {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          padding: 12,
          color: "#4B5563",
          borderColor: "#D1D5DB80",
          whiteSpace: "nowrap",

          "&.cell-right": {
            justifyContent: "flex-end",
            textAlign: "right",
            "& > *": {
              justifyContent: "flex-end",
              margin: "0 0 0 auto"
            },
            "& .MuiOutlinedInput-input": {
              textAlign: "right"
            }
          },
          "&.cell-center": {
            justifyContent: "center",
            textAlign: "center",
            "& > *": {
              justifyContent: "center",
              margin: "0 auto"
            }
          }
        },
        sizeSmall: {
          padding: 8
        },
        head: {
          fontSize: "14px",
          fontWeight: 600,
          color: "#111827",
          backgroundColor: "#F5F6FA",
          ...commonCell
        },
        footer: {
          fontSize: "0.75rem",
          textTransform: "uppercase",
          ...commonCell
        }
      }
    }
  };
}
